"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.injectAsyncRunner = exports.injectRunner = exports.useInject = void 0;
const react_1 = require("react");
const enum_1 = require("../common/enum");
/**
 * 自由地在给定的环节注入代码，谨慎使用，因为可能会影响到正常的业务逻辑
 */
function useInject(props) {
    const afterBuildOrderItemRef = (0, react_1.useRef)(null);
    const afterReturnBuildOrderItemRef = (0, react_1.useRef)(null);
    const afterThrowBuildOrderItemRef = (0, react_1.useRef)(null);
    const beforeBuildOrderItemRef = (0, react_1.useRef)(null);
    const aroundBuildOrderItemRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        if (props === null || props === void 0 ? void 0 : props[enum_1.InjectablePoint.OnBuildOrderItem]) {
            afterBuildOrderItemRef.current = props === null || props === void 0 ? void 0 : props[enum_1.InjectablePoint.OnBuildOrderItem].after;
            afterReturnBuildOrderItemRef.current = props === null || props === void 0 ? void 0 : props[enum_1.InjectablePoint.OnBuildOrderItem].afterReturn;
            afterThrowBuildOrderItemRef.current = props === null || props === void 0 ? void 0 : props[enum_1.InjectablePoint.OnBuildOrderItem].afterThrow;
            beforeBuildOrderItemRef.current = props === null || props === void 0 ? void 0 : props[enum_1.InjectablePoint.OnBuildOrderItem].before;
            aroundBuildOrderItemRef.current = props === null || props === void 0 ? void 0 : props[enum_1.InjectablePoint.OnBuildOrderItem].around;
        }
    }, [props, props === null || props === void 0 ? void 0 : props[enum_1.InjectablePoint.OnBuildOrderItem]]);
    const afterQueryPriceRef = (0, react_1.useRef)(null);
    const afterReturnQueryPriceRef = (0, react_1.useRef)(null);
    const afterThrowQueryPriceRef = (0, react_1.useRef)(null);
    const beforeQueryPriceRef = (0, react_1.useRef)(null);
    const aroundQueryPriceRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        if (props === null || props === void 0 ? void 0 : props[enum_1.InjectablePoint.OnQueryPrice]) {
            afterQueryPriceRef.current = props === null || props === void 0 ? void 0 : props[enum_1.InjectablePoint.OnQueryPrice].after;
            afterReturnQueryPriceRef.current = props === null || props === void 0 ? void 0 : props[enum_1.InjectablePoint.OnQueryPrice].afterReturn;
            afterThrowQueryPriceRef.current = props === null || props === void 0 ? void 0 : props[enum_1.InjectablePoint.OnQueryPrice].afterThrow;
            beforeQueryPriceRef.current = props === null || props === void 0 ? void 0 : props[enum_1.InjectablePoint.OnQueryPrice].before;
            aroundQueryPriceRef.current = props === null || props === void 0 ? void 0 : props[enum_1.InjectablePoint.OnQueryPrice].around;
        }
    }, [props, props === null || props === void 0 ? void 0 : props[enum_1.InjectablePoint.OnQueryPrice]]);
    const afterCheckOrderRef = (0, react_1.useRef)(null);
    const afterReturnCheckOrderRef = (0, react_1.useRef)(null);
    const afterThrowCheckOrderRef = (0, react_1.useRef)(null);
    const beforeCheckOrderRef = (0, react_1.useRef)(null);
    const aroundCheckOrderRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        if (props === null || props === void 0 ? void 0 : props[enum_1.InjectablePoint.OnCheckOrder]) {
            afterCheckOrderRef.current = props === null || props === void 0 ? void 0 : props[enum_1.InjectablePoint.OnCheckOrder].after;
            afterReturnCheckOrderRef.current = props === null || props === void 0 ? void 0 : props[enum_1.InjectablePoint.OnCheckOrder].afterReturn;
            afterThrowCheckOrderRef.current = props === null || props === void 0 ? void 0 : props[enum_1.InjectablePoint.OnCheckOrder].afterThrow;
            beforeCheckOrderRef.current = props === null || props === void 0 ? void 0 : props[enum_1.InjectablePoint.OnCheckOrder].before;
            aroundCheckOrderRef.current = props === null || props === void 0 ? void 0 : props[enum_1.InjectablePoint.OnCheckOrder].around;
        }
    }, [props, props === null || props === void 0 ? void 0 : props[enum_1.InjectablePoint.OnCheckOrder]]);
    return {
        [enum_1.InjectablePoint.OnBuildOrderItem]: (0, react_1.useMemo)(() => ({
            afterRef: afterBuildOrderItemRef,
            afterReturnRef: afterReturnBuildOrderItemRef,
            afterThrowRef: afterThrowBuildOrderItemRef,
            beforeRef: beforeBuildOrderItemRef,
            aroundRef: aroundBuildOrderItemRef,
        }), []),
        [enum_1.InjectablePoint.OnQueryPrice]: (0, react_1.useMemo)(() => ({
            afterRef: afterQueryPriceRef,
            afterReturnRef: afterReturnQueryPriceRef,
            afterThrowRef: afterThrowQueryPriceRef,
            beforeRef: beforeQueryPriceRef,
            aroundRef: aroundQueryPriceRef,
        }), []),
        [enum_1.InjectablePoint.OnCheckOrder]: (0, react_1.useMemo)(() => ({
            afterRef: afterCheckOrderRef,
            afterReturnRef: afterReturnCheckOrderRef,
            afterThrowRef: afterThrowCheckOrderRef,
            beforeRef: beforeCheckOrderRef,
            aroundRef: aroundCheckOrderRef,
        }), []),
    };
}
exports.useInject = useInject;
function injectRunner(proceed, args, injectModule) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    let result;
    let err;
    if (!injectModule) {
        return proceed(...args);
    }
    try {
        (_b = injectModule === null || injectModule === void 0 ? void 0 : (_a = injectModule.beforeRef).current) === null || _b === void 0 ? void 0 : _b.call(_a, args, proceed);
        result = (injectModule === null || injectModule === void 0 ? void 0 : injectModule.aroundRef.current)
            ? injectModule.aroundRef.current(args, proceed)
            : proceed(...args);
        if (injectModule === null || injectModule === void 0 ? void 0 : injectModule.afterReturnRef.current) {
            result = injectModule === null || injectModule === void 0 ? void 0 : injectModule.afterReturnRef.current(args, result);
        }
        (_d = injectModule === null || injectModule === void 0 ? void 0 : (_c = injectModule.afterRef).current) === null || _d === void 0 ? void 0 : _d.call(_c, args, result, err);
        return result;
    }
    catch (error) {
        err = error;
        (_f = injectModule === null || injectModule === void 0 ? void 0 : (_e = injectModule.afterThrowRef).current) === null || _f === void 0 ? void 0 : _f.call(_e, args, err);
        (_h = injectModule === null || injectModule === void 0 ? void 0 : (_g = injectModule.afterRef).current) === null || _h === void 0 ? void 0 : _h.call(_g, args, result, err);
        throw err;
    }
}
exports.injectRunner = injectRunner;
function injectAsyncRunner(proceed, args, injectModule) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    return __awaiter(this, void 0, void 0, function* () {
        let result;
        let err;
        if (!injectModule) {
            return yield proceed(...args);
        }
        try {
            yield ((_b = injectModule === null || injectModule === void 0 ? void 0 : (_a = injectModule.beforeRef).current) === null || _b === void 0 ? void 0 : _b.call(_a, args, proceed));
            result = (injectModule === null || injectModule === void 0 ? void 0 : injectModule.aroundRef.current)
                ? yield injectModule.aroundRef.current(args, proceed)
                : yield proceed(...args);
            if (injectModule === null || injectModule === void 0 ? void 0 : injectModule.afterReturnRef.current) {
                result = yield (injectModule === null || injectModule === void 0 ? void 0 : injectModule.afterReturnRef.current(args, result));
            }
            (_d = injectModule === null || injectModule === void 0 ? void 0 : (_c = injectModule.afterRef).current) === null || _d === void 0 ? void 0 : _d.call(_c, args, result, err);
            return result;
        }
        catch (error) {
            err = error;
            (_f = injectModule === null || injectModule === void 0 ? void 0 : (_e = injectModule.afterThrowRef).current) === null || _f === void 0 ? void 0 : _f.call(_e, args, err);
            (_h = injectModule === null || injectModule === void 0 ? void 0 : (_g = injectModule.afterRef).current) === null || _h === void 0 ? void 0 : _h.call(_g, args, result, err);
            throw err;
        }
    });
}
exports.injectAsyncRunner = injectAsyncRunner;
